<template>
  <div>
    <banner-m></banner-m>
    <banner-pc @play="$emit('play')"></banner-pc>
  </div>
</template>

<script>
import bannerM from '../banner-m'
import bannerPc from './banner-pc'

export default {
  components: {
    bannerM,
    bannerPc
  }
}
</script>
